// Types
import type { MenuType } from "../types"
import { PERMISION } from "security"

export const financeMenu = {
  menu: [
    {
      label: "REGISTER",
      link: "/finance/register",
      permission: PERMISION.FINANCE.REGISTER.PERMISION
    },
    {
      label: "TRANSACTION",
      link: "#",
      permission: PERMISION.FINANCE.TRANSACTION.PERMISION,
      children: [
        { label: "SPEND MONEY", link: "/finance/transaction/spend-money", permission: PERMISION.FINANCE.TRANSACTION.SPEND_MONEY.PERMISION },
        { label: "RECEIVE MONEY", link: "/finance/transaction/receive-money", permission: PERMISION.FINANCE.TRANSACTION.RECEIVE_MONEY.PERMISION },
        { label: "TRANSFER MONEY", link: "/finance/transaction/transfer-money", permission: PERMISION.FINANCE.TRANSACTION.TRANSFER_MONEY.PERMISION },
        { label: "RECONCILE ACCOUNT", link: "/finance/transaction/reconcile-account", permission: PERMISION.FINANCE.TRANSACTION.RECONCILE_ACCOUNT.PERMISION },
      ]
    },
    {
      label: "REPORT",
      link: "#",
      permission: PERMISION.FINANCE.REPORT.PERMISION,
      children: [
        { label: "DASHBOARD", link: "/finance/report/dashboard", permission: PERMISION.FINANCE.REPORT.DASHBOARD.PERMISION }
      ]
    },
    {
      label: "JOURNAL",
      link: "/finance/journal",
      permission: PERMISION.FINANCE.JOURNAL.PERMISION
    },
    {
      label: "FIND",
      link: "/finance/find",
      permission: PERMISION.FINANCE.FIND.PERMISION
    }
  ] as MenuType[]
}